;(function (Wishlist, $) {

  var stored = localStorage.getItem('user_wishlist');
  var wishlist = stored ? JSON.parse(stored) : [];

  var $wishlitcounter = $('.wishlist-counter');
  localStorage.setItem('user_wishlist_count', wishlist.length);
  $wishlitcounter.html(wishlist.length);

  var animateWishlist = function (self) {
    $(self).toggleClass('is-active');
  };

  var updateWishlist = function (self) {
    var productHandle = $(self).attr('data-product-handle');
    var isRemove = $(self).hasClass('is-active');
    if (isRemove) {
      wishlist.splice(wishlist.indexOf(productHandle), 1);
    } else {
      wishlist.push(productHandle);
    }
    localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
    localStorage.setItem('user_wishlist_count', wishlist.length);
    $wishlitcounter.html(wishlist.length);
  };

  var activateItemsInWishlist = function () {
    $('.wishlist-btn').each(function () {
      if (wishlist.indexOf($(this).attr('data-product-handle')) > -1) {
        $(this).addClass('is-active');
      }
    });
  };

  var displayOnlyWishlistItems = function () {
    $('.wishlist-tile-container').each(function () {
      if (wishlist.indexOf($(this).attr('data-product-handle')) === -1) {
        $(this).remove();
      }
    });
  };

  var loadWishlist = function () {
    if (window.location.href.indexOf('pages/wishlist') > -1) {
      displayOnlyWishlistItems();
      var remaining = $('.wishlist-tile-container').length;
      $('.wishlist-loader').fadeOut(2000, function () {
        $('.wishlist-grid').addClass('is_visible');
        $('.wishlist-hero').addClass('is_visible');
        if (remaining == 0) {
          $('.wishlist-grid-empty-list').addClass('is_visible');
          $('.wishlist-grid').hide();
        } else {
          $('.wishlist-grid-empty-list').hide();
        }
      });
    }
  };

  Wishlist.init = function () {
    $(document).on('click', '.wishlist-btn', function (e) {
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
    });
    activateItemsInWishlist();
    loadWishlist();
  };

  $(document).on('click', '#remove-done', function () {
    wishlist = [];
    localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
    localStorage.setItem('user_wishlist_count', 0);
    $wishlitcounter.html(0);
    location.reload(true);
  });

}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));

Wishlist.init();

function reloadPage() {
  location.reload(true);
}
